export const PREFIX_TITLE = 'Esfera'
